import type { ActivationMetadataItem, ActionableInsightsParams } from "app/pages/activation/types/api";

export const buildActionableInsightsParams = (
    activeActivation: ActivationMetadataItem | null,
): ActionableInsightsParams => ({
    activationId: activeActivation?.id ?? "",
    mainDomain: activeActivation?.primaryDomain ?? "",
    country: activeActivation?.country ?? 0,
    competitors: activeActivation?.competitorsDomains ?? [],
});

export const isActionableInsightsQueryEnabled = (params: ActionableInsightsParams): boolean =>
    Boolean(params.activationId && params.mainDomain && params.country && params.competitors.length);
